import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
const badgeWrapperCss = "bzdppbf";
export const BetaBadge = ({
  label
}) => <span className={badgeWrapperCss}>
    <Badge type="new">{label ?? I18n.t('publisher.left_navigation.beta')}</Badge>
  </span>;

require("./beta-badge.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./beta-badge.js");